/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { UiCommItem, UiRelease } from '../products.models';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

// Dialog box to show the details of one item in My Products.
@Component({
  selector: 'wsn-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  commItems: UiCommItem[];
  commItemsPage: UiCommItem[];
  readonly pageSize = 25;
  pageNumber: number;
  treeControl = new NestedTreeControl<UiCommItem>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<UiCommItem>();

  constructor(public dialogRef: MatDialogRef<OrderDetailsComponent>, @Inject(MAT_DIALOG_DATA) public data: UiRelease) {}

  ngOnInit(): void {
    this.commItems = this.data.comm_items;
    this.commItemsPage = this.commItems.slice(0, this.pageSize);
    this.dataSource.data = this.commItemsPage;
  }

  hasChild = (_: number, node: UiCommItem) => !!node.children && node.children.length > 0;

  handlePageEvent(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    const start = this.pageNumber * this.pageSize;
    const end = start + this.pageSize;
    this.commItemsPage = this.commItems.slice(start, end);
    this.dataSource.data = this.commItemsPage;
  }

  isExpired(date: string): boolean {
    const isExpired = new Date() > new Date(date);
    return isExpired;
  }

  close() {
    this.dialogRef.close();
  }
}
